import React from 'react';
import { Route } from 'react-router-dom';
import { GroupsEnum } from '@/types/users';
import { RoleRoute } from './RouteGuards';

const OutsourcingPage = React.lazy(() => import('@/pages/Outsourcing/OutsourcingPage'));
const OutsourceFormPage = React.lazy(() => import('@/pages/Outsourcing/OutsourceFormPage'));
const OpenShiftPage = React.lazy(() => import('@/pages/Outsourcing/OpenShiftPage'));
const OutsourcePhotoPage = React.lazy(() => import('@/pages/Outsourcing/OutsourcePhotoPage'));
const AcceptCheckinPage = React.lazy(() => import('@/pages/Outsourcing/AcceptCheckinPage'));
const EditSessionPage = React.lazy(() => import('@/pages/Outsourcing/EditSessionPage'));
const AnotherUserPage = React.lazy(() => import('@/pages/Outsourcing/AnotherUserPage'));

const outsourcingRoute = (path: string, element: React.ReactNode) => (
  <Route
    key={path}
    path={path}
    element={<RoleRoute groups={[GroupsEnum.OUTSOURCE]}>{element}</RoleRoute>}
  />
);

const routeDefinitions = [
  { path: 'outsourcing', element: <OutsourcingPage /> },
  { path: 'outsourcing/add', element: <OutsourceFormPage /> },
  { path: 'outsourcing/edit/:outsourceId', element: <OutsourceFormPage /> },
  { path: 'outsourcing/open/:sessionId', element: <OpenShiftPage /> },
  { path: 'outsourcing/another/:sessionId', element: <AnotherUserPage /> },
  {
    path: 'outsourcing/photo/:outsourceId/:userId/:sessionId?',
    element: <OutsourcePhotoPage />,
  },
  {
    path: 'outsourcing/accept/:outsourceId/:mode/:imageId?/:sessionId?',
    element: <AcceptCheckinPage />,
  },
  { path: 'outsourcing/edit-session/:sessionId', element: <EditSessionPage /> },
];

export const outsourcingRoutePaths = routeDefinitions.map(({ path }) => path);
export const outsourcingRoutes = routeDefinitions.map(({ path, element }) =>
  outsourcingRoute(path, element),
);
